import { BaseCamelCasedResource } from "./BasePlainResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
class BusinessGuarantorSignerResource extends BaseCamelCasedResource {
    pk() {
        return this.customerId.toString();
    }
}
BusinessGuarantorSignerResource.urlRoot = legacyApiResourceUrl("/Signer/GetBusinessGuarantors/");
export { BusinessGuarantorSignerResource };
//# sourceMappingURL=BusinessGuarantorSignerResource.js.map